import C from '../actionTypes';
import { messageConverter } from '../../helpers/Helper';

export const unreadMessageList = (state = [], action) => {
    switch (action.type) {
        case C.GET_UNREAD_MESSAGES_REQUEST:
            return { ...state, isLoading: true };
        case C.GET_UNREAD_MESSAGES_SUCCESS:
            return action.arrMessages;
        case C.READ_MESSAGE_SUCCESS:
            let newState = {...state};
            const message = newState[action.accountId].find( msg => msg._id === action.messageId );
            message.status = 'read';
            return newState;
        default:
            return state
    }
};

export const messageList = (state = [], action) => {
    switch (action.type) {
        case C.GET_MESSAGES_REQUEST:
            return { ...state, isLoading: true };
        case C.GET_MESSAGES_SUCCESS:
            return action.arrMessages.filter(msg => messageConverter(msg));
        case C.READ_MESSAGE_SUCCESS:
            let newState = {...state};
            const message = newState[action.accountId].find( msg => msg._id === action.messageId );
            message.status = 'read';
            return newState;
        default:
            return state
    }
};

export const openedMessageIds = (state = [], action) => {
    switch (action.type) {
        case C.OPEN_MESSAGE:
            return [...state, action.messageId];
        case C.CLOSE_MESSAGE:
            return [...state, action.messageId];
        default:
            return state
    }
};

export const countOfUnreadMessages = (state = 0, action) => {
    switch (action.type) {
        case C.SET_UNREAD_MESSAGES_COUNT:
            return action.count;
        default:
            return state
    }
};

export const openedMessage = (state = null, action) => {
    switch (action.type) {
        case C.SET_OPENED_MESSAGE:
            return action.message;
        case C.CLOSE_OPENED_MESSAGE:
            return null;
        default:
            return state
    }
};